import React, { useEffect, useState, useRef, memo } from 'react';
export const MultiBanner = memo(function MultiBanner() {
  const banners = [{
    id: 1,
    title: '1/3 WIDTH BANNER',
    subtitle: 'DIMENSIONS',
    description: 'ASPECT RATIO 3:1',
    image: '',
    bgColor: 'bg-gray-300'
  }, {
    id: 2,
    title: '1/3 WIDTH BANNER',
    subtitle: 'DIMENSIONS',
    description: 'ASPECT RATIO 3:1',
    image: '',
    bgColor: 'bg-gray-300'
  }, {
    id: 3,
    title: '1/3 WIDTH BANNER',
    subtitle: 'DIMENSIONS',
    description: 'ASPECT RATIO 3:1',
    image: '',
    bgColor: 'bg-gray-300'
  }, {
    id: 4,
    title: '1/3 WIDTH BANNER',
    subtitle: 'DIMENSIONS',
    description: 'ASPECT RATIO 3:1',
    image: '',
    bgColor: 'bg-gray-300'
  }, {
    id: 5,
    title: '1/3 WIDTH BANNER',
    subtitle: 'DIMENSIONS',
    description: 'ASPECT RATIO 3:1',
    image: '',
    bgColor: 'bg-gray-300'
  }, {
    id: 6,
    title: '1/3 WIDTH BANNER',
    subtitle: 'DIMENSIONS',
    description: 'ASPECT RATIO 3:1',
    image: '',
    bgColor: 'bg-gray-300'
  }];
  const scrollerRef = useRef<HTMLDivElement>(null);
  const [activePage, setActivePage] = useState(0);
  const CARDS_PER_PAGE_MOBILE = 2;
  const totalPages = Math.ceil(banners.length / CARDS_PER_PAGE_MOBILE);
  const handleScroll = () => {
    const el = scrollerRef.current;
    if (!el) return;
    const page = Math.round(el.scrollLeft / el.clientWidth);
    setActivePage(page);
  };
  const goToPage = (page: number) => {
    const el = scrollerRef.current;
    if (!el) return;
    el.scrollTo({
      left: page * el.clientWidth,
      behavior: 'smooth'
    });
  };
  useEffect(() => {
    const el = scrollerRef.current;
    if (!el) return;
    el.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => el.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="w-full" data-id="element-2567" data-mp="2anojdsyml0rb">
      <div className="container mx-auto px-4" data-id="element-2568" data-mp="2aohhy6nfkjyd">
        {/* Desktop: 6-col grid */}
        <div className="hidden md:grid md:grid-cols-3 lg:grid-cols-6 gap-3" data-id="element-2569" data-mp="2fmj0mqgy2h9b">
          {banners.map(banner => <a key={banner.id} href="#" className={`relative aspect-[5/2] overflow-hidden rounded-lg ${banner.bgColor} transition-transform hover:scale-105`} style={{
          willChange: 'transform'
        }} data-id="element-2570" data-mp="2klm78fckovje">
              {banner.image && <img src={banner.image} alt="" className="absolute inset-0 h-full w-full object-cover" data-id="element-2571" data-mp="1wxcltej9u9ss" />}
              <div className="absolute inset-0 flex flex-col justify-center p-3 text-gray-800" data-id="element-2572" data-mp="20x3cli8sspxb">
                <span className="text-xs font-bold bg-white text-gray-600 px-2 py-0.5 rounded-full w-max mb-2" data-id="element-2573" data-mp="25penth8zny56">
                  {banner.subtitle}
                </span>
                <h3 className="text-sm font-bold mb-1" data-id="element-2574" data-mp="1d7sgwf6b1lq1">{banner.title}</h3>
                <p className="text-xs font-medium" data-id="element-2575" data-mp="1d5xzhau8sbqp">{banner.description}</p>
              </div>
            </a>)}
        </div>

        {/* Mobile: Paginated Slider */}
        <div className="md:hidden" data-id="element-2576" data-mp="10qho1zwgnloz">
          <div ref={scrollerRef} className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide" data-id="element-2577" data-mp="wnuvfwrytwqq">
            {Array.from({
            length: totalPages
          }).map((_, pageIdx) => {
            const pageItems = banners.slice(pageIdx * CARDS_PER_PAGE_MOBILE, pageIdx * CARDS_PER_PAGE_MOBILE + CARDS_PER_PAGE_MOBILE);
            return <div key={pageIdx} className="flex-shrink-0 w-full snap-start grid grid-cols-2 gap-3 px-1" data-id="element-2578" data-mp="d0nd5nvpc77d" data-mpi={pageIdx}>
                  {pageItems.map(banner => <a key={banner.id} href="#" className={`relative block aspect-[5/2] overflow-hidden rounded-lg ${banner.bgColor}`} data-id="element-2579" data-mp="3ynu6q14mt1s">
                      {banner.image && <img src={banner.image} alt="" className="absolute inset-0 h-full w-full object-cover" data-id="element-2580" data-mp="241f9dzspck4s" />}
                      <div className="absolute inset-0 flex flex-col justify-center p-3 sm:p-4 text-gray-800" data-id="element-2581" data-mp="1pdkimoy98puc">
                        <span className="text-[10px] sm:text-xs font-bold bg-white text-gray-600 px-2 py-0.5 rounded-full w-max mb-2" data-id="element-2582" data-mp="1uau63z232rfj">
                          {banner.subtitle}
                        </span>
                        <h3 className="text-sm sm:text-base font-bold mb-1 leading-tight" data-id="element-2583" data-mp="1kehb8xusy7j7">
                          {banner.title}
                        </h3>
                        <p className="text-xs font-medium" data-id="element-2584" data-mp="1bcrjts0x78lf">
                          {banner.description}
                        </p>
                      </div>
                    </a>)}
                </div>;
          })}
          </div>

          {/* Pagination dots */}
          <div className="flex items-center justify-center gap-2 mt-4" data-id="element-2585" data-mp="u35tegjt5yuz">
            {Array.from({
            length: totalPages
          }).map((_, i) => <button key={i} onClick={() => goToPage(i)} aria-label={`Go to page ${i + 1}`} className={`h-2 rounded-full transition-all ${activePage === i ? 'w-6 bg-[#1E2B55]' : 'w-2 bg-gray-300 hover:bg-gray-400'}`} data-id="element-2586" data-mp="p2hw5d4zklsb" data-mpi={i} />)}
          </div>
        </div>
      </div>
    </div>;
});